import React from 'react';

import { Dialog } from '@shared/components';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import Checkbox from '@material-ui/core/Checkbox';

import useStyles from './style';

const noop = () => {};
const DownloadWarning = ({
  isOpen = false,
  isDownloadingData = false,
  extensionType = 'Limited',
  confirmState = {},
  onClose = noop,
  onDownloadConfirm = noop,
  handleChange = noop,
}) => {
  const classes = useStyles();

  //JSX
  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      open={isOpen}
      onClose={() => {
        if (!isDownloadingData) onClose();
      }}
      classes={{
        paper: classes.downloadConfirmModal,
      }}
    >
      <Dialog.Title hasClose />
      <Dialog.Content>
        <Typography variant='h5' className='mb-3'>
          Confirm Action
        </Typography>
        <div className='mb-3'>
          <Typography variant='body1' className='bold-font mt-2 mb-5'>
            Please confirm the following:
          </Typography>
          <div>
            <Checkbox
              color='primary'
              size='small'
              name='firstWarning'
              checked={confirmState.firstWarning}
              onChange={handleChange}
              disabled={isDownloadingData}
            />
            <Typography variant='caption' className={classes.instructionsBody}>
              I will DELETE every line I do not want to change (not just filter
              them out)
            </Typography>
          </div>
          <div>
            <Checkbox
              color='primary'
              size='small'
              name='thirdWarning'
              checked={confirmState.thirdWarning}
              onChange={handleChange}
              disabled={isDownloadingData}
            />
            <Typography variant='caption' className={classes.instructionsBody}>
              {extensionType === 'Limited'
                ? `I understand that if I leave the PIN or Password fields blank, the
            extension will be disabled and not function correctly.`
                : `I understand that if I use this tool to remove X's from the user's 
              contact email, the notification email will not necessarily change along with it.`}
            </Typography>
          </div>
        </div>
      </Dialog.Content>
      <Dialog.Actions>
        <>
          <Button
            variant='outlined'
            color='primary'
            className='mb-4 mr-4'
            onClick={onClose}
            disabled={isDownloadingData}
          >
            Cancel
          </Button>
          <Button
            variant='contained'
            color='primary'
            className='mr-4 mb-4'
            onClick={onDownloadConfirm}
            disabled={
              !(confirmState.firstWarning && confirmState.thirdWarning) ||
              isDownloadingData
            }
          >
            {isDownloadingData && (
              <CircularProgress size={24} className='p-absolute color-grey' />
            )}
            Download
          </Button>
        </>
      </Dialog.Actions>
    </Dialog>
  );
};
export default DownloadWarning;
